import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden grain bg-cream pt-32 pb-20 md:pt-40 md:pb-28"
    >
      <span aria-hidden className="hero-monogram" style={{ top: "10%", right: "-2%" }}>
        M
      </span>

      <div className="container-edit relative">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-8 reveal in-view">
              <Sparkles size={16} className="text-gold-deep" />
              <span className="eyebrow">A Boutique AI Studio &nbsp;&middot;&nbsp; Est. 2026</span>
            </div>

            <h1 data-testid="hero-headline" className="h-display text-plum-deepest mb-8">
              Your website
              <br />
              <span className="font-display-italic text-plum">should talk back.</span>
            </h1>

            <p
              data-testid="hero-subhead"
              className="text-lg md:text-xl text-muted-plum leading-relaxed max-w-xl mb-10 font-body"
            >
              Custom AI chatbots that <span className="text-plum-deepest font-semibold">book appointments, qualify leads, and never sleep.</span> Built by{" "}
              <span className="text-plum-deepest font-semibold">Melanie</span> — a PhD-credentialed builder who delivers boutique-studio quality without the agency price tag.
            </p>

            <div className="flex flex-wrap gap-4 mb-12">
              <a href="#demos" data-testid="hero-cta-primary" className="btn-primary">
                Try a live demo
                <ArrowRight size={18} />
              </a>
              <a href="#services" data-testid="hero-cta-secondary" className="btn-secondary">
                See pricing
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-x-10 gap-y-5 pt-8 border-t border-plum/10">
              <Stat number="5 days" label="Avg. build time" />
              <Stat number="24/7" label="Working for you" />
              <Stat number="100%" label="Custom built" />
              <Stat number="$125+" label="Starting at" />
            </div>
          </div>

          <div className="lg:col-span-5 relative">
            <div className="card-plum relative overflow-hidden">
              <div className="absolute -top-10 -right-10 w-40 h-40 rounded-full bg-gold/20 blur-3xl pointer-events-none" />
              <div className="relative">
                <span className="eyebrow text-gold mb-4 block">Now Booking</span>
                <h3 className="font-display text-3xl text-cream mb-4 leading-tight">
                  The 24/7 employee your business has been <span className="font-display-italic">missing.</span>
                </h3>
                <p className="text-cream/80 font-body mb-6 text-sm leading-relaxed">
                  Trained on your business. Embedded on your site. Live in 5 business days.
                </p>
                <div className="space-y-3 text-cream/90 text-sm">
                  <FeatureRow text="Trained on your real FAQs & docs" />
                  <FeatureRow text="Captures leads while you sleep" />
                  <FeatureRow text="No code on your end — ever" />
                </div>
                <a href="#contact" data-testid="hero-card-cta" className="btn-gold mt-7">
                  Book a project
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

function Stat({ number, label }) {
  return (
    <div>
      <div className="font-display text-2xl md:text-3xl text-plum-deepest leading-none">
        {number}
      </div>
      <div className="text-xs uppercase tracking-widest text-muted-plum mt-1.5">
        {label}
      </div>
    </div>
  );
}

function FeatureRow({ text }) {
  return (
    <div className="flex items-start gap-3">
      <span className="text-gold mt-1">◆</span>
      <span>{text}</span>
    </div>
  );
}
